import axios, { AxiosInstance } from 'axios';
import Constants from '../constants/constants';
import LoggedAdminStorage from '../local_storage/logged_admin_storage';
import { routes } from '@/router';

class BffFoodPassBackofficeApiRequester {

  private static axios: AxiosInstance | null = null;

  public static getAxios(): AxiosInstance {
    if (BffFoodPassBackofficeApiRequester.axios) return BffFoodPassBackofficeApiRequester.axios;
    BffFoodPassBackofficeApiRequester.axios = axios.create({
      baseURL: Constants.getBffEndpoint()
    });
    BffFoodPassBackofficeApiRequester.axios.interceptors.request.use(async (config) => {
      config.headers.Authorization = `Bearer ${LoggedAdminStorage.getToken()}`;
      return config;
    });
    BffFoodPassBackofficeApiRequester.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.data.error.message === 'Token expired') {
          const url = new URL(routes.login.path, window.location.origin);
          window.location.href = url.href;
        }
        return Promise.reject(error);
      }
    );
    return BffFoodPassBackofficeApiRequester.axios;
  }
}

export default BffFoodPassBackofficeApiRequester;